module.exports = __webpack_public_path__ + "img/HTCC-BMP180.8b8b5d6f.jpg";